import { Box, Grid, useMediaQuery } from '@material-ui/core';
import { OrangeButton } from 'components/Button';
import Modal from 'components/Modal';
import messages from 'components/MenuItem/messages';
import { SizedLongBody, StyledBodyText } from 'containers/LoginPage/styles';
import {
  StyledPic,
  StyledPicResponsive,
} from 'containers/SignupPages/AuthByContract/styles';
import { AssuranceIcon } from 'images';
import React from 'react';
import { useIntl } from 'react-intl';
import { PRIVILEGES } from 'utils/globalConst';

interface PolicyNumberModalProps {
  handleOpen: any;
  handleClose: any;
  open: boolean;
  typeAssurance?: any;
}

const PolicyNumberModal = ({
  handleOpen,
  handleClose,
  open,
  typeAssurance,
}: PolicyNumberModalProps) => {
  const { formatMessage } = useIntl();
  const isNotMobile = useMediaQuery('(min-width:960px)');
  return (
    <Modal
      open={open}
      handleOpen={handleOpen}
      handleClose={handleClose}
      header={
        <SizedLongBody weight="500" color="#04336B">
          {formatMessage(messages.modalHeader)}
        </SizedLongBody>
      }
      content={
        <Box paddingX={2}>
          <StyledBodyText>
            {formatMessage(messages.modalContent)}
          </StyledBodyText>
          <Box marginTop={3} marginBottom={3}>
            <Grid container justify="center">
              <Grid item>
                {typeAssurance === PRIVILEGES.AUTO &&
                  (isNotMobile ? (
                    <StyledPic src={AssuranceIcon.policyNumberImage} />
                  ) : (
                    <StyledPicResponsive
                      src={AssuranceIcon.policyNumberImage}
                    />
                  ))}
                {/* {typeAssurance === PRIVILEGES.MRH && (
                  <StyledPic src={AssuranceIcon.mrhPolicyNumberImage} />
                )}
                {typeAssurance === PRIVILEGES.EPARGN && (
                  <StyledPic src={AssuranceIcon.epargnPolicyNumberImage} />
                )} */}
              </Grid>
            </Grid>
          </Box>
        </Box>
      }
      footer={
        <Grid container justify="flex-end">
          <Grid item>
            <OrangeButton variant="contained" onClick={handleClose}>
              {formatMessage(messages.close)}
            </OrangeButton>
          </Grid>
        </Grid>
      }
    ></Modal>
  );
};

export default PolicyNumberModal;
